import script from "./UiModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UiModal.vue?vue&type=script&setup=true&lang=js"

import "./UiModal.vue?vue&type=style&index=0&id=11b7a6ea&lang=scss"

const __exports__ = script;

export default __exports__